var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJewelry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    style: {
      height: 512,
      width: 512
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-bg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h512v512H0z",
    fill: "#417505",
    fillOpacity: 0,
    transform: "translate(512, 512) scale(-1, -1) rotate(-180, 256, 256) skewX(0) skewY(0)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h512v512H0z",
    fill: "#417505",
    fillOpacity: 0
  })), /*#__PURE__*/React.createElement("g", {
    className: "",
    transform: "translate(0,0)",
    style: {}
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M471.1 30.58l17.8 2.84S476 114.1 448.1 204.9c5.4 4.6 8.9 11.5 8.9 19.1 0 13.2-10.5 24.2-23.5 25-18 50.4-40.6 100.6-68.8 139.3-9.1 12.5-18.8 23.8-29.2 33.6-3.9-4.7-8.9-8.6-14.5-11.2 10.2-9.1 19.9-20.2 29.2-33 26.4-36.2 48.5-84.9 66.1-134.3-5.7-4.6-9.3-11.6-9.3-19.4 0-13.4 10.8-24.4 24-25 27.4-89 40.1-168.42 40.1-168.42zm-430.19 0S53.71 110 81.01 199c13.2.5 23.99 11.6 23.99 25 0 7.8-3.7 14.8-9.29 19.4 17.59 49.4 39.69 98.1 66.09 134.3 9.3 12.8 19 23.9 29.2 33-5.6 2.6-10.6 6.5-14.5 11.2-10.4-9.8-20.1-21.1-29.2-33.6-28.2-38.7-50.69-88.9-68.79-139.3-13-.8-23.5-11.8-23.5-25 0-7.6 3.5-14.5 8.9-19.1-27.9-90.8-40.8-171.48-40.8-171.48zM407.1 62.52l17.8 2.96S417 113.4 393 162.2V208h-18v-14.5c-9.6 14.3-20.8 27.9-34.1 39.3-3.8 3.2-7.8 6.3-11.9 9.2v46h-18v-35.5c-13.8 6.7-29.2 11-46 12.2V304h-18v-39.3c-16.8-1.2-32.2-5.5-46-12.2V288h-18v-46c-4.1-2.9-8.1-6-11.9-9.2-13.3-11.4-24.5-25-34.1-39.3V208h-18v-45.8c-23.99-48.8-31.89-96.72-31.89-96.72l17.79-2.96s7.9 46.88 31.2 93.48c11.6 23.3 27 46.3 46.8 63.2 19.7 16.9 43.3 27.8 73.1 27.8 29.8 0 53.4-10.9 73.1-27.8 19.8-16.9 35.2-39.9 46.8-63.2 23.3-46.6 31.2-93.48 31.2-93.48zM304 425c12.8 0 23 10.2 23 23s-10.2 23-23 23c-2.6 0-5.1-.4-7.4-1.2.2-1.9.4-3.8.4-5.8 0-11.3-4.6-21.5-12.1-28.9C289 429 296 425 304 425zm-96 0c8 0 15 4 19.1 10.1-7.5 7.4-12.1 17.6-12.1 28.9 0 2 .2 3.9.4 5.8-2.3.8-4.8 1.2-7.4 1.2-12.8 0-23-10.2-23-23s10.2-23 23-23zm48 16c12.8 0 23 10.2 23 23s-10.2 23-23 23-23-10.2-23-23 10.2-23 23-23z",
    fill: "#a36528",
    fillOpacity: 1,
    clipPath: "url(#icon-bg)",
    transform: "translate(512, 512) scale(-1, -1) rotate(-180, 256, 256) skewX(0) skewY(0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJewelry);
export default __webpack_public_path__ + "static/media/jewelry.0ee8490bb63bce7e3016e3e301783f58.svg";
export { ForwardRef as ReactComponent };